import { identity, keyBy, mapValues } from "lodash";

const getPublicUrlImage = (name, { prefix = "", type = ".png" } = {}) =>
  `${process.env.PUBLIC_URL}${prefix}/${name}${type}`;

const mascot = getPublicUrlImage("mascot");
const ant = getPublicUrlImage("ant", { prefix: "/images" });
const beetle = getPublicUrlImage("beetle", { prefix: "/images" });
const bee = getPublicUrlImage("bee", { prefix: "/images" });
const fly = getPublicUrlImage("fly", { prefix: "/images" });
const scorpion = getPublicUrlImage("scorpion", { prefix: "/images" });
const spider = getPublicUrlImage("spider", { prefix: "/images" });
const snail = getPublicUrlImage("snail", { prefix: "/images" });
const cockroach = getPublicUrlImage("cockroach", { prefix: "/images" });
const centipede = getPublicUrlImage("centipede", { prefix: "/images" });
const ladybug = getPublicUrlImage("ladybug", { prefix: "/images" });
const butterfly = getPublicUrlImage("butterfly", { prefix: "/images" });
const dragonfly = getPublicUrlImage("dragonfly", { prefix: "/images" });
const earthworm = getPublicUrlImage("catterpillar", { prefix: "/images" });
const stinkbug = getPublicUrlImage("beetle2", { prefix: "/images" });
const cricket = getPublicUrlImage("bug", { prefix: "/images" });
const prayingMantis = getPublicUrlImage("prayingMantis", { prefix: "/images" });
const portraits = mapValues(
  keyBy([1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 20], identity),
  (v) => getPublicUrlImage(`portrait${v}`, { prefix: "/images" })
);

export const PORTRAIT_IMAGES_BLOODLINES = [
  mascot,
  ant,
  beetle,
  bee,
  fly,
  scorpion,
  spider,
  snail,
  cockroach,
  centipede,
  ladybug,
  butterfly,
  dragonfly,
  earthworm,
  stinkbug,
  cricket,
  prayingMantis,
  portraits[12],
  portraits[5],
  portraits[7],
];

export const PORTRAIT_IMAGES_ORIGINS = [];

export const PORTRAIT_IMAGES_POSTS = [];

export const DEFAULT_CHARACTER_PORTRAIT = mascot;
export const HORIZONEER_PORTRAIT = earthworm;

export const PORTRAIT_IMAGES = [
  ...PORTRAIT_IMAGES_BLOODLINES,
  ...PORTRAIT_IMAGES_ORIGINS,
  ...PORTRAIT_IMAGES_POSTS,
];
